import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Button from "../Buttons/Button";
import InputWithValidation from "../Textfield";
import { colors } from "@mui/material";

interface Login2FAFormProps {
  otp: string;
  helperText: string;
  loading: boolean;
  onOTPChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handle2FASubmit: (e: React.FormEvent) => void
  cancel2FA: (e: React.FormEvent) => void
}

const Login2FAForm: React.FC<Login2FAFormProps> = ({
    otp,
    helperText,
    loading,
    onOTPChange,
    handle2FASubmit,
    cancel2FA
  }) => (
    <form className="w-full max-w-sm mx-auto space-y-4" onSubmit={handle2FASubmit}>
      <InputWithValidation
        label="OTP"
        autoComplete="off"
        helperText={helperText}
        value={otp}
        onChange={onOTPChange}
        fullWidth
      />
      
      <Button
        label={loading ? "Loading..." : "Submit"}
        onClick={handle2FASubmit}
        className={`w-full p-3 text-white bg-gradient-to-b from-primary to-secondary 
                rounded hover:bg-orange-600 ${loading ? "bg-gray-400 cursor-not-allowed" : `bg-[${colors.orange}]`}`}
        disabled={loading}
        type="submit"
      />
      <div className="flex justify-center">
        <Button
          type="button"
        //   style={{ color: colors.orange }}
          className="text-sm hover:underline mt-6"
          onClick={cancel2FA}
          label={
            <>
              <span className="text-gradient-to-b from-primary to-secondary hover:underline hover:text-black">
                Cancel
              </span>
            </>
          }
        />
      </div>
    </form>
  );


export default Login2FAForm;
